import type { CustomizationEntity } from '~/cards/reducers/projectReducer';

export const isCustomizationActive = (customization: CustomizationEntity) => {
  return typeof customization.inactive === 'boolean'
    ? !customization.inactive
    : !customization.deleted_at;
};
